import type { SVGProps } from "react";
export default function SvgSortDownLetters(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-arrow-down-az-icon lucide-arrow-down-a-z"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m3 16 4 4 4-4" />
			<path d="M7 20V4" />
			<path d="M20 8h-5" />
			<path d="M15 10V6.5a2.5 2.5 0 0 1 5 0V10" />
			<path d="M15 14h5l-5 6h5" />
		</svg>
	);
}
